export const DISPLAYNAME_MAX_LENGTH = 40;

// Latin letters (incl. accents), numbers, spaces, and common name punctuation
export const DISPLAYNAME_REGEX =
  /^[\p{Script=Latin}\p{Nd}\s.\-/'&,]*$/u;

export const DISPLAYNAME_FORMAT_ERROR =
  'Your name can only include standard letters and numbers, plus spaces and basic punctuation.';

export const isValidDisplayname = (value) =>
  !value || (value.trim().length > 0 && DISPLAYNAME_REGEX.test(value));

export const getDisplaynameFormatError = (value) =>
  isValidDisplayname(value) ? null : DISPLAYNAME_FORMAT_ERROR;
